import { useUser } from '@/hooks';
import { Avatar, Link, Menu, MenuButton, MenuItem } from '@chakra-ui/react';

export const LoggedUserAvatar: React.FC = (): JSX.Element => {
  const user = useUser();

  const username = user?.firstName ? `${user.firstName} ${user.lastName}` : undefined;

  return (
    <Menu>
      {username ? (
        <MenuItem
          _active={{ bg: 'transparent' }}
          _focus={{ bg: 'transparent' }}
          _hover={{ textDecoration: 'none' }}
          as={Link}
          href="/user/my-account"
          w="unset"
        >
          <MenuButton
            aria-label="Options"
            as={Avatar}
            bgColor="transparent"
            color="white"
            cursor="pointer"
            name={username}
            showBorder
          />
        </MenuItem>
      ) : (
        <MenuButton
          aria-label="Options"
          as={Avatar}
          bgColor="transparent"
          cursor="pointer"
          showBorder
        />
      )}
    </Menu>
  );
};
